import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { AbstractNotificationDirective } from "../_shared/abstract/abstract-notification.directive";
import { NotificationContentComponent } from "../_shared/notification-content/notification-content.component";
import { AppViewVar } from "@model";
import { NotificationHeaderComponent } from "../_shared/notification-header/notification-header.component";

@Component({
  selector: "app-offline-notification",
  standalone: true,
  imports: [TranslateModule, NotificationContentComponent, NotificationHeaderComponent],
  templateUrl: "./offline-notification.component.html",
  styleUrl: "./offline-notification.component.scss",
})
export class OfflineNotificationComponent extends AbstractNotificationDirective {
  colorVariable = AppViewVar.VIEW_OFFLINE_NOTIFICATION_BACKGROUND_COLOR;
}
